import * as React from "react";
import {LocationDescriptor} from "history";
import URI from "urijs";
import {MouseEvent} from "react";
import styles = require("./style.less");
import InternalRedirect from "../Navigation/InternalRedirect/InternalRedirect";
import ActionButton, {ActionButtonType} from "components/Button/ActionButton";

interface NavigationButtonProps {
    label: string;
    titleAltText?: string;
    href: NavigationPath | string;
    icon?: JSX.Element;
    external?: boolean;
    disabled?: boolean;
    type?: NavigationButtonType;
}

interface NavigationPath {
    path: string;
    search: {[name: string]: string};
}

interface NavigationButtonState {
    navigate: boolean;
}

export enum NavigationButtonType {
    Primary,
    Secondary
}

export class NavigationButton extends React.Component<NavigationButtonProps, NavigationButtonState> {
    getPath(): LocationDescriptor {
        if (typeof this.props.href === "string") {
            return this.props.href;
        }

        const query = URI.buildQuery(this.props.href.search);
        return {
            pathname: this.props.href.path,
            search: `?${query}`
        };
    }

    handleOnClick = (e: MouseEvent<{}>): void => {
        e.preventDefault();
        this.setState({ navigate: true });
    }

    render() {
        if (this.state && this.state.navigate) {
            if (this.props.external) {
                this.setState({navigate: false});
                window.open(this.props.href as string);
            } else {
                return <InternalRedirect to={this.getPath()} push={true} />;
            }
        }

        const buttonType = this.props.type === NavigationButtonType.Primary
            ? ActionButtonType.Primary
            : ActionButtonType.Ternary;

        return <span className={styles.globalActionButton}>
            <ActionButton
                label={this.props.label}
                type={buttonType}
                icon={this.props.icon}
                disabled={this.props.disabled}
                onClick={this.handleOnClick}
            />
        </span>;
    }
}

export default NavigationButton;
